import { SnackbarContext } from '@/contexts/SnackbarContext';
import { useContext } from 'react';

const useJSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useJSnackbar must be used within a JsnackbarProvider');
  }
  return context;
};

export default useJSnackbar;
